/**
 * React Native WebView のユーティリティ関数
 */

// declare global for React Native WebView
declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (message: string) => void;
            injectedObjectJson: () => string;
        };
    }
}

/**
 * ネイティブアプリに送信するメッセージの型
 */
interface NativeAppMessage {
    event: string;
    data: unknown;
    _metadata: {
        type: 'data';
        version: number;
    };
}

/**
 * React Native WebViewであるかを判定する
 * @returns {boolean} WebView内ならtrue、それ以外ならfalse
 */
export const isReactNativeWebView = (): boolean => {
    return typeof window !== 'undefined' && window.ReactNativeWebView !== undefined;
};

/**
 * ネイティブアプリにメッセージを送信する
 * @param {string} event - イベント名
 * @param {unknown} data - 送信するデータ
 * @returns {boolean} 送信成功ならtrue、失敗ならfalse
 */
export const sendMessageToNativeApp = (event: string, data: unknown): boolean => {
    try {
        if (
            isReactNativeWebView() &&
            window.ReactNativeWebView // 型エラーを発生させないため
        ) {
            const message: NativeAppMessage = {
                event,
                data,
                _metadata: {
                    type: 'data',
                    version: 1,
                },
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
            return true;
        }
        return false;
    } catch (error) {
        console.error('Failed to send message to native app:', error);
        return false;
    }
};

/**
 * WebView内のネイティブアプリから注入されたオブジェクトを取得する
 * @returns {unknown} 注入されたオブジェクト、存在しない場合はnull
 */
export const getInjectedObjectFromNativeApp = (): unknown => {
    try {
        if (
            isReactNativeWebView() &&
            window.ReactNativeWebView // 型エラーを発生させないため
        ) {
            return JSON.parse(window.ReactNativeWebView.injectedObjectJson());
        }
        return null;
    } catch (error) {
        console.error(`Failed to get injected object from native app:`, error);
        return null;
    }
};
